<template>
  <section id="processo" class="how-section" aria-labelledby="how-title">
    <div class="how-inner">

      <header class="how-header">
        <h2 id="how-title" class="how-title">Come lavoriamo</h2>
        <p class="how-subtitle">
          Il nostro intervento segue un percorso chiaro e progressivo. Ogni fase ha un obiettivo preciso e si integra con il metodo Sportemocracy.
        </p>
      </header>

      <!-- Step #01 — full width, white -->
      <article class="how-step how-step--01">
        <span class="step-num">#01</span>
        <h3 class="how-step-title">Analisi del contesto</h3>
        <p class="how-step-text">
          Partiamo dall'ascolto e dall'analisi della realtà specifica della società sportiva: organizzazione interna, calendario, età degli atleti, risorse disponibili e obiettivi stagionali. L'obiettivo è comprendere prima di proporre.
        </p>
      </article>

      <!-- Steps #02–04 -->
      <div class="how-grid">
        <article class="how-step how-step--primary">
          <span class="step-num">#02</span>
          <h3 class="how-step-title">Definizione del percorso</h3>
          <p class="how-step-text">
            Sulla base dell'analisi, definiamo un piano strutturato di preparazione atletica, con criteri chiari di progressione, monitoraggio e verifica. Il piano viene condiviso con staff e dirigenza per garantire coerenza operativa.
          </p>
        </article>

        <article class="how-step how-step--primary">
          <span class="step-num">#03</span>
          <h3 class="how-step-title">Creazione piani di allenamento</h3>
          <p class="how-step-text">
            Definiremo assieme una programmazione per la stagione agonistica, individuando i punti salienti per ogni gruppo/atleta, e fissando dei check-point attraverso i quali ogni atleta dovrà passare per raggiungere l'obiettivo finale.
          </p>
        </article>

        <article class="how-step how-step--primary">
          <span class="step-num">#04</span>
          <h3 class="how-step-title">Monitoraggio e adattamento</h3>
          <p class="how-step-text">
            La preparazione atletica non è statica. Prevediamo momenti di verifica e adattamento, per mantenere coerenza con l'andamento della stagione, la risposta degli atleti e le esigenze organizzative.
          </p>
        </article>
      </div>

      <p class="how-footer">
        Questo percorso costituisce la base su cui stiamo sviluppando la piattaforma digitale, che permetterà di supportare e rendere ancora più organizzabile il lavoro quotidiano.
      </p>

    </div>
  </section>
</template>

<script>
export default {
  name: 'HowWeWorkSection'
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

// ── Sezione ──────────────────────────────────────────────
.how-section {
  background-color: $white;
  color: $black;
}

.how-inner {
  padding: 56px 24px;
  display: flex;
  flex-direction: column;
  gap: 0;
}

// ── Header ───────────────────────────────────────────────
.how-header {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
}

.how-title {
  margin: 0;
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.2;
}

.how-subtitle {
  margin: 0;
  font-size: 1.05rem;
  line-height: 1.7;
  color: rgba($black, 0.85);
}

// ── Step base ────────────────────────────────────────────
.step-num {
  font-size: 1.875rem;
  font-weight: 700;
  color: $black;
}

.how-step-title {
  margin: 0;
  font-size: 1.75rem;
  font-weight: 700;
  line-height: 1.2;
}

.how-step-text {
  margin: 0;
  font-size: 1rem;
  line-height: 1.6;
}

// ── Step #01 ─────────────────────────────────────────────
.how-step--01 {
  border: 1px solid $black;
  border-radius: 25px;
  padding: 1.5rem;
  background-color: $white;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

// ── Grid #02–04 ──────────────────────────────────────────
.how-grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 24px;
}

.how-step--primary {
  background-color: $primary;
  border-radius: 25px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 12px;
  color: $white;

  .step-num,
  .how-step-title {
    color: $white;
  }
}

// ── Footer ───────────────────────────────────────────────
.how-footer {
  margin: 24px 0 0;
  font-size: 1.05rem;
  line-height: 1.7;
  color: rgba($black, 0.85);
}

// ── Tablet portrait (≥768px) ──────────────────────────────
@media (min-width: 768px) {

  .how-inner {
    padding: 64px 40px;
  }

  .how-step--01 {
    padding: 2rem;
  }

  .how-grid {
    gap: 20px;
    margin-top: 32px;
  }

  .how-step--primary {
    padding: 1.5rem;
  }

  .how-footer {
    margin-top: 32px;
  }
}

// ── Tablet landscape + Desktop ────────────────────────────
@media (min-width: 900px) and (orientation: landscape) {

  .how-inner {
    padding: 80px 120px;
  }

  .how-title {
    font-size: 2.4rem;
  }

  .how-subtitle,
  .how-footer {
    font-size: 1.15rem;
  }

  .how-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 32px;
    margin-top: 48px;
  }

  .how-step--primary {
    padding: 2rem;
  }
}
</style>
